import Router from "next/router";
import { jwtService } from "services";

export const SET_USER_DATA = "[USER] SET DATA";
export const REMOVE_USER_DATA = "[USER] REMOVE USER";
export const USER_LOGGED_OUT = "[USER] LOGGED OUT";

/**
 *  Set User Data
 */
export const setUserData = (user) => {
  return (dispatch) =>
    dispatch({
      type: SET_USER_DATA,
      payload: user,
    });
};

/**
 * Update User Data
 */
// export const updateUserData = (user) => {
// jwtService
//   .updateUserData(user)
//   .then(() => {
//     console.log("User data saved with api");
//   })
//   .catch((error) => {
//     console.log(error.message);
//   });

// return (dispatch) =>
//   dispatch({
//     type: SET_USER_DATA,
//     payload: user,
//   });
// };

/**
 * Remove User Data
 */
export const removeUserData = () => {
  return {
    type: REMOVE_USER_DATA,
  };
};

/**
 * Logout
 */
export const logoutUser = () => {
  return (dispatch) => {
    if (process.browser) {
      window.location.href = process.env.NEXT_PUBLIC_APP_SSO_LOGIN
    }

    jwtService.logout();

    dispatch({
      type: USER_LOGGED_OUT,
    });
  };
};
